import {
    avatarClassName,
    buttonClassName,
    dividerClassName,
    labelClassName,
    pxToRem,
} from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';
import {
    AVATAR_BG_COLOR,
    AVATAR_OVERLAY_OFFSET,
} from '~/modules/design-board/config';

export const FilterBarAvatars: StyleRule = ({ theme }) => ({
    columnGap: pxToRem(6),
    alignItems: 'center',
    marginTop: pxToRem(-3),
    zIndex: theme.siteVariables.zIndexes.foreground,
    cursor: 'pointer',
    [`& .${avatarClassName}`]: {
        backgroundColor: AVATAR_BG_COLOR,
        borderColor: theme.siteVariables.colors.grey[100],
        borderWidth: '1px',
        [`& .${labelClassName}`]: {
            fontSize: pxToRem(14),
            color: theme.siteVariables.colors.primitive.black,
        },
        [`&.has-image`]: {
            borderWidth: 0,
        },
    },

    [`& .${dividerClassName}`]: {
        height: pxToRem(40),
        padding: 0,
        marginRight: pxToRem(-1),
        ':before': {
            background: theme.siteVariables.colors.grey[100],
        },
    },
});

export const BoardAvatarIcon: StyleRule = ({ hasImage = false }) => ({
    borderWidth: hasImage ? 0 : '1px',
});

export const InviteButton: StyleRule = () => ({
    width: pxToRem(40),
    height: pxToRem(40),
    borderRadius: '50%',
    [`& .${svgIconClassName}`]: {
        width: pxToRem(26),
        height: pxToRem(26),
    },
});

export const Collaborators: StyleRule = ({ theme }) => ({
    marginLeft: pxToRem(AVATAR_OVERLAY_OFFSET),
    [`& .${avatarClassName}`]: {
        marginLeft: pxToRem(-AVATAR_OVERLAY_OFFSET),
        zIndex: 0,
        ':nth-child(2)': {
            zIndex: theme.siteVariables.zIndexes.background,
        },
        ':nth-child(3)': {
            zIndex: theme.siteVariables.zIndexes.foreground,
        },
    },

    [`& > .${buttonClassName}`]: {
        marginLeft: pxToRem(-AVATAR_OVERLAY_OFFSET),
        zIndex: theme.siteVariables.zIndexes.overlayPriority,
        borderRadius: '50%',
        background: '#F6F6F6', // not in aria
    },
});
